<script lang="ts">
    import { Table } from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {getUserWithdrawals} from 'src/components/cabinet/#services/getUserWithdrawals'
    import {copyClipboard} from 'src/global/copyClipboard'
    import IconifyIcon from '@iconify/svelte'
    import copyIcon from '@iconify/icons-fa-solid/copy'
    import {roundNumber} from 'src/components/#common/helpers'

    export let userId

    let currentPage = 0
    let perPage = 25
    let maxButtons = 5
    let totalCount = 5

    $: getUserWithdrawals.send({
        data: {
            userId,
            page: currentPage + 1,
            perPage,
        },
    })

    async function copy(value) {
        copyClipboard(value)
    }

    function getWithdrawalLink(network, currency) {
        if (network === 'near') {
            if (currency === 'WLIS') {
                return 'https://nearblocks.io/token/token.v1.realisnetwork.near?a='
            }
            return 'https://nearblocks.io/address/'
        } else if (network === 'polygon') {
            return 'https://polygonscan.com/address/'
        }
    }
</script>

<div class="transactions-list">
    <Table bordered striped responsive>
        <thead>
        <tr>
            <td class="text-center">Status</td>
            <td class="text-center">Amount</td>
            <td class="text-center">Network</td>
            <td class="text-center">Address</td>
            <td class="text-center">Date</td>
        </tr>
        </thead>
        <tbody>
        {#if $getUserWithdrawals.loading}
            {#each {length:perPage} as item}
                <tr>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                </tr>
            {/each}
        {:else if $getUserWithdrawals.error || !$getUserWithdrawals.hasValue }
            <tr>
                <td class="text-center" colspan="5">Something went wrong. Try refreshing the page.</td>
            </tr>
        {:else}
            {#each $getUserWithdrawals.value.data as { recipientAddress, amount, fee, network, currency, status, createdAt }}
                <tr>
                    <td>
                        {#if status === 'onApproving' || status === 'approved'}
                            <span class="status-pending">Pending</span>
                        {:else if status === 'onConfirmation'}
                            <span class="status-pending">Email sent</span>
                        {:else if status === 'notApproved' || status === 'notConfirmed' || status === 'error'}
                            <span class="status-returned">Returned</span>
                        {:else if status === 'success'}
                            <span class="status-success">Success</span>
                        {:else}
                            {status}
                        {/if}
                    </td>
                    <td>{roundNumber(+amount - +fee)} {#if currency === 'TLIS'}LIS{:else}{currency}{/if}</td>
                    <td>{network || 'near'}</td>
                    <td>
                        <a href="{getWithdrawalLink(network, currency)}{recipientAddress}" class="address" target="_blank" rel="noreferrer">
                            {#if recipientAddress.length >= 20}
                                {recipientAddress.slice(0,7)}...{recipientAddress.slice(-7)}
                            {:else}
                                {recipientAddress}
                            {/if}
                        </a>
                        <button class="btn copy-btn" on:click={copy(recipientAddress)}>
                            <IconifyIcon icon={copyIcon} class="side-nav-icon"/>
                        </button>
                    </td>
                    <td class="text-center">{new Date(createdAt).toLocaleString()}</td>
                </tr>
            {:else}
                <tr>
                    <td class="text-center" colspan="4">No items</td>
                </tr>
            {/each}
        {/if}
        </tbody>
    </Table>
    {#if $getUserWithdrawals.hasValue}
        <Pagination
            bind:currentPage={currentPage}
            totalCount={$getUserWithdrawals.value.totalCount}
            {perPage}
            {maxButtons}
            disabled={$getUserWithdrawals.loading || $getUserWithdrawals.loading}
        />
    {/if}
</div>

<style>
    .transactions-list :global(table) {
        width: auto;
    }

    .transactions-list :global(td) {
        vertical-align: middle;
        padding: 12px 25px;
        line-height: normal;
    }

    .status-success {
        color: #27AE60;
    }

    .status-pending {
        color: #ff9800;
    }

    .status-returned {
        color: #da4848;
    }

    .transactions-list :global(nav .pagination) {
        justify-content: flex-start;
    }

    .copy-btn {
        font-size: 14px;
        line-height: 11px;
        background: #8391a2;
        color: white;
        padding: 4px 5px;
        margin: -4px 0 -3px 4px;
        transition: .15s;
    }

    .copy-btn:hover {
        background: #768494;
    }
</style>
